import SignUpModal from './SignUpModal';
import SignInModal from './SignInModal';

const modals = {
  signUpModal: SignUpModal,
  signInModal: SignInModal
};

export default modals;
